import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCheckFull = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <circle cx={10} cy={10} r={8} />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M14.33 6.727a.777.777 0 0 1 0 1.099l-5.29 5.291c-.42.42-1.101.423-1.525.007l-2.083-2.046A.777.777 0 0 1 6.521 9.97l1.75 1.72 4.962-4.963a.776.776 0 0 1 1.098 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCheckFull;
